import { ref, update } from "firebase/database";
import { useState } from "react";
import { db } from "../Firebase";

const RemoveHold = ({ registrationId, onSuccess, buttonText = "✅ Remove Hold", buttonClass = "btn-success" }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRemoveHold = async () => {
    setLoading(true);
    try {
      const updateData = {
        [`meta/status`]: 'approved',
        [`meta/approvedAt`]: new Date().toISOString(),
        [`meta/holdReason`]: null,
        [`meta/holdAt`]: null
      };

      await update(ref(db, `registration/${registrationId}`), updateData);
      
      setShowModal(false);
      alert('Hold removed successfully! Registration is now approved.');
      if (onSuccess) onSuccess();
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={`btn btn-sm ${buttonClass}`}
        onClick={() => setShowModal(true)}
      >
        {buttonText}
      </button>

      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">✅ Remove Hold</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to remove the hold and approve this registration?</p>
                <p className="text-muted">This will clear the hold reason and mark the registration as approved.</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button 
                  className="btn btn-success" 
                  onClick={handleRemoveHold}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Confirm Remove Hold'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RemoveHold;